import { render, staticRenderFns } from "./m_image.vue?vue&type=template&id=1843aba2&"
import script from "./m_image.vue?vue&type=script&lang=js&"
export * from "./m_image.vue?vue&type=script&lang=js&"
import style0 from "./m_image.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports